import commonConfig from "../../../../config/common";

const updateSizeMappingIndex = (state, { payload: { clientWidth } }) => {
  const {
    adverts: { sizeMappings }
  } = commonConfig;

  const sizeMappingIndex = sizeMappings.findIndex(
    ({ viewPortSize: [width] }) => width <= clientWidth
  );

  return {
    ...state,
    sizeMappingIndex
  };
};

export default updateSizeMappingIndex;
